import { Pusher } from "pusher-js";
import { apiUrl, getStaticConfiguration } from "@/config/app";
import Echo from "laravel-echo";
import _ from "lodash";
import { onReadyPromise } from "@/services/Auth2";

type EchoOptions = {
  client: unknown;
  broadcaster: string;
  key?: string;
  cluster: string;
  encrypted: boolean;
  authEndpoint: string;
  auth?: Record<string, unknown>;
};

function getDefaultOptions(): Promise<EchoOptions> {
  return getStaticConfiguration().then((config) => {
    return {
      client: Pusher,
      broadcaster: "pusher",
      key: config.PUSHER_KEY,
      cluster: config.PUSHER_CLUSTER || "us2",
      encrypted: true,
      authEndpoint: `${apiUrl.getInstance()}/api/broadcast/auth`,
    };
  });
}

function clientBuilder(options: Partial<EchoOptions> = {}): Promise<Echo> {
  return getDefaultOptions().then(
    (defaultOptions) => new Echo(_.merge(defaultOptions, options))
  );
}

export function echoClientFactory(): Promise<Echo> {
  return onReadyPromise.then(
    ({ client, token }) => {
      return clientBuilder({
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      });
    },
    (_error) => {
      return clientBuilder();
    }
  );
}
